/* eslint-disable */
import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext(null);

const INITIAL_MESSAGE = {
  id: 1,
  text: "Halo! Saya asisten AI cerdas dari Kantor Hukum. Ada yang bisa saya bantu terkait layanan hukum atau konsultasi?",
  isBot: true,
};

export function ChatProvider({ children }) {
  const [messages, setMessages] = useState([INITIAL_MESSAGE]);
  const [isTyping, setIsTyping] = useState(false);

  const sendMessage = async (text) => {
    if (!text.trim()) return;

    const userMessage = { id: Date.now(), text, isBot: false };
    setMessages((prev) => [...prev, userMessage]);
    setIsTyping(true);

    try {
      const historyFormatted = messages
        .filter((msg) => msg.id !== 1)
        .map((msg) => ({
          role: msg.isBot ? "model" : "user",
          parts: [{ text: msg.text }],
        }));

      const response = await fetch(
        "https://lawfirm-landing-page-worker.seleniumdigitalsolution.workers.dev",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ message: text, history: historyFormatted }),
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const rawText = await response.text();
      console.log("Raw Response dari Worker:", rawText);

      const cleanedText = rawText
        .replace(/```json\n?/g, "")
        .replace(/```/g, "")
        .trim();

      let data;
      try {
        data = JSON.parse(cleanedText);
        console.log("Parsed Data:", data);
      } catch (e) {
        console.error("Gagal parse JSON:", cleanedText);
        throw new Error("Format balasan AI tidak valid");
      }

      if (data.isRedirect === true || data.isRedirect === "true") {
        const waNumber = "6282253210449";
        const textTemplate = `Halo, saya butuh konsultasi lanjutan.\n\n*Kategori Hukum:* ${data.category}\n*Rangkuman:* ${data.summary}`;
        const encodedUrl = `https://wa.me/${waNumber}?text=${encodeURIComponent(textTemplate)}`;

        setMessages((prev) => [
          ...prev,
          {
            id: Date.now() + 1,
            isBot: true,
            isRedirect: true,
            waUrl: encodedUrl,
            text: `Rangkuman percakapan telah dibuat (${data.category}). Silakan lanjutkan ke WhatsApp.`,
          },
        ]);
      } else {
        setMessages((prev) => [
          ...prev,
          { id: Date.now() + 1, text: data.reply, isBot: true },
        ]);
      }
    } catch (error) {
      console.error("Error:", error);
      setMessages((prev) => [
        ...prev,
        {
          id: Date.now() + 1,
          text: "Maaf, terjadi gangguan server. Silakan coba lagi.",
          isBot: true,
        },
      ]);
    } finally {
      setIsTyping(false);
    }
  };

  return (
    <ChatContext.Provider value={{ messages, isTyping, sendMessage }}>
      {children}
    </ChatContext.Provider>
  );
}

export function useChat() {
  const ctx = useContext(ChatContext);
  if (!ctx) throw new Error("useChat must be used inside <ChatProvider>");
  return ctx;
}
